import { getFormattedDate } from '../../../../helpers/localize';
import { TABLE_KEYS } from '../../../../redux_store';
import DownloadTableFile from '../../../Shared/Table/widgets/TopBar/DownloadTableFile';
import MetricsButton from '../../../Shared/Table/widgets/MetricsButton';
import { useSelector } from 'react-redux';

const TableActions = (props) => {
  const { isDistributionSponsor } = useSelector((state) => state.user);
  const tableKey = isDistributionSponsor ? TABLE_KEYS.assessmentsDSTable : TABLE_KEYS.assessmentsTable;

  return <>
    <MetricsButton title={'assessments'}
                   aggregations={props.aggregations}
                   filter={props.tableFilter}
    />
    <DownloadTableFile
      fileName={`Assessments ${getFormattedDate(new Date(Date.now()))}.csv`}
      endpoint={'/export-surveys.csv'}
      tableKey={tableKey}
      {...props}
    />
  </>;
};

export default TableActions;
